import { Component, Input, OnInit } from '@angular/core';
import { transform } from 'ol/proj';
import {Map} from 'ol'

@Component({
  selector: 'app-custom-nav-controller',
  templateUrl: './custom-nav-controller.component.html',
  styleUrls: ['./custom-nav-controller.component.scss']
})
export class CustomNavControllerComponent implements OnInit {

  @Input() map: Map;
  
  constructor() { }

  ngOnInit() {
  }

  Extent(){
    if (this.map) {
      this.map.getView().setCenter(transform([-74, 4], 'EPSG:4326', 'EPSG:3857'));
      this.map.getView().setZoom(5);
    }
  }

  zoomIn() {
    if (this.map) {
      const view = this.map.getView();
      view.setZoom(view.getZoom() + 1);
    }
  }

  zoomOut() {
    if (this.map) {
      const view = this.map.getView();
      view.setZoom(view.getZoom() - 1);
    }
  }
}
